import { useConsent } from '@/hooks/analytics'
import { cn } from '@/lib/utils'

type CookiePreferencesLinkProps = {
  className?: string
  children?: React.ReactNode
}

// Renders a button that resets cookie consent so the banner re-opens.
// Drop into footers next to the privacy policy link.
export const CookiePreferencesLink = ({
  className,
  children = 'Cookie preferences',
}: CookiePreferencesLinkProps) => {
  const { reset } = useConsent()

  return (
    <button
      type="button"
      onClick={reset}
      className={cn('text-inherit hover:underline', className)}
    >
      {children}
    </button>
  )
}
